import { render } from "./ColorItemCustom.vue?vue&type=template&id=6decc6b0&scoped=true"
import script from "./ColorItemCustom.vue?vue&type=script&lang=js"
export * from "./ColorItemCustom.vue?vue&type=script&lang=js"

import "./ColorItemCustom.vue?vue&type=style&index=0&id=6decc6b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6decc6b0"]])

export default __exports__